var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "none",
    fill: "currentColor",
    viewBox: "0 0 20 20",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0258 13.8473L18.595 17.4157L17.4158 18.5948L13.8475 15.0257C12.5198 16.09 10.8683 16.6689 9.16666 16.6665C5.02666 16.6665 1.66666 13.3065 1.66666 9.1665C1.66666 5.0265 5.02666 1.6665 9.16666 1.6665C13.3067 1.6665 16.6667 5.0265 16.6667 9.1665C16.6691 10.8682 16.0902 12.5196 15.0258 13.8473ZM13.3542 13.229C14.4118 12.1414 15.0024 10.6835 15 9.1665C15 5.94317 12.3892 3.33317 9.16666 3.33317C5.94332 3.33317 3.33332 5.94317 3.33332 9.1665C3.33332 12.389 5.94332 14.9998 9.16666 14.9998C10.6837 15.0022 12.1416 14.4116 13.2292 13.354L13.3542 13.229Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.173bc312bffa5f9f8d5571f8b2239929.svg";
export { ForwardRef as ReactComponent };